import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';

import TripOptions from '../TripOptions/TripOptions';

import styles from './DropdownMenu.scss';

const propTypes = {
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    rootUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    isExternal: PropTypes.bool,
    linkKey: PropTypes.string,
    native: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const defaultProps = {
    className: '',
    onClick() { },
    rootUrl: '',
    isExternal: false,
};

class DropdownMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    _toggleMenu = (isOpen) => {
        this.setState(() => ({ isOpen }));
    };

    _closeMenu = () => {
        this._toggleMenu(false);
        this.props.onClick();
    };

    _openMenu = () => {
        this._toggleMenu(true);
    };

    render() {
        const {
            className,
            href,
            title,
            linkKey,
            native,
            options,
            locale,
            rootUrl,
            isExternal,
        } = this.props;

        const {
            isOpen,
        } = this.state;
        const url = isExternal
            ? `https://www.wanderu.com/${locale}${href}`
            : href;
        const linkTarget = isExternal
            ? '_blank'
            : undefined;

        return (
            <nav
                className={classNames(
                    styles.dropdown,
                    {
                        [styles.visible]: isOpen,
                    },
                )}
                data-id="dropdownMenu"
                onMouseLeave={this._closeMenu}
            >
                <A
                    className={className}
                    data-id="transMode"
                    href={url}
                    native={!!rootUrl}
                    onClick={this._closeMenu}
                    onMouseEnter={this._openMenu}
                    target={linkTarget}
                    underline="none"
                >
                    {title}
                </A>
                {!isExternal && (
                    <TripOptions
                        className={styles.options}
                        linkKey={linkKey}
                        locale={locale}
                        native={native}
                        onClick={this._closeMenu}
                        optionClassName={styles.option}
                        options={options}
                        rootUrl={rootUrl}
                    />
                )}
            </nav>
        );
    }
}

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

export default DropdownMenu;
